document.addEventListener('DOMContentLoaded', () => {
  const searchBar = document.getElementById('table-search-bar');
  const table = document.getElementById('searchable-table');
  if (searchBar && table) {
    const rows = table.getElementsByTagName('tr');

    searchBar.addEventListener('keyup', () => {
      const filter = searchBar.value.toLowerCase();

      for (let i = 1; i < rows.length; i++) { // Start from 1 to skip the header row
        const row = rows[i];
        const cells = row.getElementsByTagName('td');
        let match = false;

        for (let j = 0; j < cells.length; j++) {
          const cellText = cells[j].textContent || cells[j].innerText;
          if (cellText.toLowerCase().indexOf(filter) > -1) {
            match = true;
            break; // A match in any cell is enough
          }
        }

        if (match) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      }
    });
  }
});
